import(/* webpackMode: "eager" */ "/home/ubuntu/download/69a151899c1d57001434fd38/standave/src/app/blog/page.tsx");
